import React from "react";
import { AppList } from "components/list/AppList";
import { Datagrid, EditButton, TextField } from 'react-admin';

import {DatagridWithBlockDeleteProps} from "../../../components/_helpers/props/DatagridProps";
import {stylesForColorInheritInList} from "../../../components/_helpers/useStyles";
import { PhoneField } from '../../../components/fields/PhoneField';
import { StyledEmailField } from '../../../components/fields/StyledEmailField';
import { ScrollingWrapper } from '../../../components/ScrollingWrapper';
import {HideBlockUnblockButtonIfDeleted} from "../../../components/toolbars/BlockUnblockButton";
import DeleteRestoreButtons from '../../../components/toolbars/DeleteRestoreButtons';
import { DevelopersFilter } from './ListFilters';
import { envSettings } from "core/EnvSettings";

const defaultSort = { field: 'id', order: 'DESC' };
const isServerDev = envSettings.REACT_APP_IS_SERVER_DEV;

export const DevelopersList = props => {
	const classes = stylesForColorInheritInList();

	return (
		<AppList
			{...props}
			sort={defaultSort}
			exporter={false}
			bulkActionButtons={false}
			filters={<DevelopersFilter />}
			classes={classes}
		>
			<ScrollingWrapper>
				<Datagrid {...DatagridWithBlockDeleteProps}>
					<TextField source="id" />
					<TextField source="first_name" />
					<TextField source="last_name" />
					<StyledEmailField source="email" />
					<PhoneField source="phone" />
					{isServerDev ? <StyledEmailField source="test_account_email" sortable={false} /> : null}

					<EditButton label="" />
					<HideBlockUnblockButtonIfDeleted entity={"user"}/>
					<DeleteRestoreButtons
						replaceResource="user-is-deleted"
						confirmDeleteStringKey="osfc.dialogs.confirm_delete_user"
						confirmRestoreStringKey="osfc.dialogs.confirm_restore_user"
					/>
				</Datagrid>
			</ScrollingWrapper>
		</AppList>
	);
};
